
const getUserData = () => {
    try {
      const data = localStorage.getItem("userData");
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error parsing userData from localStorage", error);
      return null;
    }
  };

  export const userRole = getUserData()?.user?.role;
  export const userId = getUserData()?.user?.id;
  export const userUid = getUserData()?.user?.uid;
  export const userPhoneNumber = getUserData()?.user?.phoneNumber;
  export const userName = getUserData()?.user?.name;
  export const userEmail = getUserData()?.user?.emailId;
  export const teamIds = getUserData()?.teamId?.map((t) => t.id);
  export const teamList = getUserData()?.teamId;
  export const teamDetails = getUserData()?.teamId
